import React from 'react';
import type { PostCallJob, PostCallStepStatus } from '../services/postCallClient';
import '../styles/components/PostCallStatus.css';

const ANALYSES = [
  { name: 'mmt', label: 'Moments', icon: 'auto_awesome' },
  { name: 'eval', label: 'Evaluation', icon: 'fact_check' },
  { name: 'summary', label: 'Summary', icon: 'summarize' },
  { name: 'adherence', label: 'Adherence', icon: 'checklist' },
  { name: 'kpi', label: 'KPI', icon: 'analytics' },
] as const;

const stateIcon = (status: PostCallStepStatus | 'not_started') => {
  if (status === 'running') return 'progress_activity';
  if (status === 'succeeded') return 'check_circle';
  if (status === 'failed') return 'error';
  if (status === 'skipped') return 'remove_circle';
  return 'radio_button_unchecked';
};

const overallLabel = (job: PostCallJob | null) => {
  if (!job) return 'Not started';
  if (job.status === 'running') return 'Analyzing';
  if (job.status === 'succeeded') return 'Ready';
  return job.status.charAt(0).toUpperCase() + job.status.slice(1);
};

interface Props {
  job: PostCallJob | null;
  compact?: boolean;
}

const PostCallStatus: React.FC<Props> = ({ job, compact = false }) => (
  <div className={`post-call-status ${compact ? 'compact' : ''}`}>
    <span className={`post-call-status-pill status-${job?.status || 'not-started'}`}>
      {overallLabel(job)}
    </span>
    <span className="post-call-step-icons">
      {ANALYSES.map(({ name, label, icon }) => {
        const step = job?.steps.find(item => item.analysis_type === name);
        const status = step?.status || 'not_started';
        return (
          <span
            key={name}
            className={`post-call-step status-${status}`}
            title={`${label} — ${status.replace('_', ' ')}`}
            aria-label={`${label}: ${status}`}
          >
            <span className="material-symbols-outlined analysis-icon">{icon}</span>
            <span className={`material-symbols-outlined state-icon ${status === 'running' ? 'spin' : ''}`}>
              {stateIcon(status)}
            </span>
          </span>
        );
      })}
    </span>
  </div>
);

export default PostCallStatus;
